import { render, staticRenderFns } from "./en-IN.vue?vue&type=template&id=faabaf90&"
import script from "./en-IN.vue?vue&type=script&lang=js&"
export * from "./en-IN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faabaf90')) {
      api.createRecord('faabaf90', component.options)
    } else {
      api.reload('faabaf90', component.options)
    }
    module.hot.accept("./en-IN.vue?vue&type=template&id=faabaf90&", function () {
      api.rerender('faabaf90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/en-IN.vue"
export default component.exports